const set = prop => (state, val) => {
  state[prop] = val
}

export const projects = set('projects')
export const currentProject = set('currentProject')
export const showWidgetGrid = set('showWidgetGrid')
export const projectQ = set('projectQ')
export const wikiProjectId = set('wikiProjectId')
export const showProjectList = set('showProjectList')
export const selectedQa = set('selectedQa')
export const dashboardEnabled = set('dashboardEnabled')
export const projectboardEnabled = set('projectboardEnabled')
export const otfComment = set('otfComment')



// WEBPACK FOOTER //
// ./src/store/modules/project/mutations.js